"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBSingleLineAuthGuardService = void 0;
const router_1 = require("@angular/router");
const operators_1 = require("rxjs/operators");
const account_service_1 = require("./account.service");
const _ = require("underscore");
const bbroles_service_1 = require("./bbroles.service");
const rxjs_1 = require("rxjs");
const constants_1 = require("./../../shared/constants");
/**
 * BB Single Line Access Auth Guard Service
 *
 * Checks if the user has the access to activate component by comparing the subId
 */
class BBSingleLineAuthGuardService {
    constructor(router, accountService, rolesService) {
        this.router = router;
        this.accountService = accountService;
        this.rolesService = rolesService;
        this.roles = constants_1.UserRole;
        this.allowedRoles = [this.roles.ACCOUNT_PRIMARY, this.roles.IT_SUPPORT];
    }
    canActivate(route, state) {
        this.subId = route.queryParamMap.get('subId');
        return rxjs_1.forkJoin([this.getAccountDetails(), this.getAllowedRolesStatus()]).pipe(operators_1.map(([details, roleAllowedStatus]) => {
            const mobileNumber = details.mobileNumber;
            this.subscriptions = details.subscription;
            if (!roleAllowedStatus && details.profileType === 'SECONDARY') {
                const sub = _.where(this.subscriptions, { mobileNumber });
                const subscriberId = _.pluck(sub, 'subscriptionId');
                if (subscriberId[0] === this.subId) {
                    return true;
                }
                else {
                    this.router.navigate(['/business/singleline'], { queryParams: { subId: subscriberId } });
                }
            }
            else {
                return true;
            }
        }), operators_1.catchError((err) => this.router.navigate(['/business'])));
    }
    getAllowedRolesStatus() {
        return this.rolesService.getRolesAndPermissions(false).pipe(operators_1.map((rolesInfo) => {
            const finalRole = _.intersection(this.allowedRoles, rolesInfo.Role);
            return finalRole.length > 0;
        }));
    }
    getAccountDetails() {
        return this.accountService.getAccountDetails(true).pipe(operators_1.map((accountDetails) => accountDetails));
    }
}
exports.BBSingleLineAuthGuardService = BBSingleLineAuthGuardService;
//# sourceMappingURL=bbsinglelineauth.service.js.map